module.exports = __webpack_public_path__ + "static/24gde-c09570b8ebc56fcac631d45f641d8471.gif";